<template>
    <div class="sp-management-container">
        <SPManagementHeader :filters="filters" :allColumns="allColumns"
            :selectedColumns="selectedColumns" :distributorID="distributorID"
            @update-search="updateGlobalSearch" @update-columns="updateColumns"
            @clear-filter="clearFilter" @export-csv="exportCSV" @open-download="openDownloadDialog"
            @open-upload="fileUpload" />

        <!-- Main Container -->
        <div class="main-container">
            <RMTable ref="rmTable" :filters="filters" :columns="selectedColumns" :all-columns="allColumns"
                @update-with-filter="handleFilterUpdate" />
        </div>

        <!-- Upload Dialog -->
        <RMUploadDialog :visible="showUploadDialog" @close="handleUploadDialogClose" />
        
        <!-- Download Dialog -->
        <RMDownloadDialog :visible="showDownloadDialog" @close="handleDownloadDialogClose" />
    </div>
</template>
<script>
import { FilterMatchMode } from '@primevue/core/api';
import RMTable from './RMTable.vue';
import RMUploadDialog from './RMUploadDialog.vue';
import RMDownloadDialog from './RMDownloadDialog.vue';
import SPManagementHeader from './SPManagementHeader.vue';
import { getDistributer } from '@/mixins/common';

export default {
    name: 'SPManagement',
    components: {
        RMTable,
        RMUploadDialog,
        RMDownloadDialog,
        SPManagementHeader
    },
    data() {
        const allColumns = [
            { field: "id", header: "ID", style: "min-width:80px !important;", sortable: true, isFilter: false },
            { field: "rmCode", header: "RM Code", style: "min-width:120px !important;", sortable: true, isFilter: true },
            { field: "manufacturerId", header: "Manufacturer ID", style: "min-width:150px !important;", sortable: true, isFilter: true },
            { field: "spCode", header: "SP Code", style: "min-width:120px !important;", sortable: true, isFilter: true },
            { field: "startDate", header: "Start Date", style: "min-width:120px !important;", sortable: true, isFilter: false },
            { field: "endDate", header: "End Date", style: "min-width:120px !important;", sortable: true, isFilter: false },
            { field: "createdDate", header: "Created Date", style: "min-width:150px !important;", sortable: true, isFilter: false },
            { field: "modifiedDate", header: "Modified Date", style: "min-width:150px !important;", sortable: true, isFilter: false },
            { field: "operatorId", header: "Operator ID", style: "min-width:120px !important;", sortable: true, isFilter: false },
            { field: "operatorReference", header: "Operator Reference", style: "min-width:150px !important;", sortable: true, isFilter: false },
            { field: "isActive", header: "Active", style: "min-width:100px !important;", sortable: true, isFilter: false },
        ];
        const defaultColumnFields = ["id", "rmCode", "manufacturerId", "spCode", "startDate", "endDate", "active"];
        return {
            filters: {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            },
            allColumns,
            selectedColumns: allColumns.filter(col => defaultColumnFields.includes(col.field)),
            showUploadDialog: false,
            showDownloadDialog: false,
            distributorID: ""
        }
    },
    mounted() {
        const distributer = getDistributer();
        if (distributer && distributer["distributerID"]) {
            this.distributorID = distributer["distributerID"] || "";
        }
    },
    methods: {
        updateGlobalSearch(value) {
            if (this.filters?.global) {
                this.filters.global.value = value;
            }
        },
        clearFilter() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS }
            };
            if (this.$refs.rmTable) {
                this.$refs.rmTable.filterUpdate('');
            }
        },
        exportCSV() {
            if (this.$refs.rmTable) {
                this.$refs.rmTable.exportCSV();
            }
        },
        fileUpload() {
            this.showUploadDialog = true;
        },
        handleUploadDialogClose() {
            this.showUploadDialog = false;
        },
        openDownloadDialog() {
            this.showDownloadDialog = true;
        },
        handleDownloadDialogClose() {
            this.showDownloadDialog = false;
        },
        handleFilterUpdate(filter) {
            console.log('Filter updated:', filter);
        },
        updateColumns(value) {
            const fallbackFields = ["id", "rmCode", "manufacturerId", "spCode", "startDate", "endDate", "isActive"];
            const fallback = this.allColumns.filter(col => fallbackFields.includes(col.field));
            this.selectedColumns = value?.length ? value : fallback;
        }
    }
}
</script>
<style scoped lang="scss">
@import '@/assets/scss/distributorVariables/variable.scss';

.sp-management-container {
    width: 100%;
    margin-top: 5.15rem;
    padding: 0 2rem;
}

.main-container {
    margin-top: 1.5rem;
    padding: 0;
}

// Mobile responsive adjustments
@media (max-width: 767px) {
    .sp-management-container {
        padding: 0 1rem;
        margin-top: 5rem; // Reduced margin for mobile
    }

    .main-container {
        margin-top: 1rem;
    }
}

@media (max-width: 480px) {
    .sp-management-container {
        padding: 0 0.75rem;
    }
}
</style>

